import token, { tokenToVars } from '../token';
import Image from './image';

export { Image };
export default tokenToVars(Image, token);
